<template>
  <div class="content dirbi-modulo" data-testid="dirbi-modulo">
    <!-- A DIRBI de LI monta o próprio cabeçalho, com as ações da página -->
    <DirbiCabecalho v-if="!isLeiInformatica || !temPermissao" :subtitulo="subtitulo"></DirbiCabecalho>

    <div class="dirbi-modulo-corpo" :class="{ 'mt-3': !isLeiInformatica || !temPermissao }">
      <template v-if="!temPermissao">
        <servico-select
          class="mb-3 dirbi-modulo-beneficio"
          data-testid="dirbi-beneficio"
        ></servico-select>
        <v-alert type="warning" text data-testid="dirbi-sem-permissao">
          Você não tem permissão para acessar a DIRBI de {{ nomeBeneficio }}.
        </v-alert>
      </template>
      <DirbiLeiInformatica v-else-if="isLeiInformatica" key="dirbi-li"></DirbiLeiInformatica>
      <DirbiLeiDoBem v-else key="dirbi-lb" class="dirbi-modulo-lb"></DirbiLeiDoBem>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { BeneficiosEnum, BeneficiosLabels } from "@/core/enums/beneficios";
import { userHasAccess } from "@/helpers/permissionValidator";
import DirbiCabecalho from "./cabecalho.vue";
import DirbiLeiDoBem from "./lei-do-bem.vue";
import DirbiLeiInformatica from "./lei-informatica.vue";

/**
 * Módulo DIRBI: a mesma tela atende Lei do Bem e Lei de Informática, trocando o conteúdo
 * pelo benefício selecionado na barra de filtros de cada uma (US 4605). As duas DIRBIs
 * continuam independentes (RN07): filtros, valores, permissões e exportação de uma não
 * afetam a outra.
 */
const PERMISSOES = {
  [BeneficiosEnum.LEI_DO_BEM]: "Dispendios.lalur.index", // TODO trocar pela permissão própria da DIRBI de LB
  [BeneficiosEnum.LEI_DE_INFORMATICA]: "Dispendios.dirbiLeiInformatica.index"
};

const SUBTITULOS = {
  [BeneficiosEnum.LEI_DO_BEM]: "Lei do Bem · valores de IRPJ e CSLL calculados a partir do LALUR",
  [BeneficiosEnum.LEI_DE_INFORMATICA]: "Lei de Informática · crédito financeiro por trimestre, a partir do Limite de Crédito do Sigplani"
};

export default {
  components: {
    DirbiCabecalho,
    DirbiLeiDoBem,
    DirbiLeiInformatica,
    "servico-select": () => import("@/components/servico-select.vue")
  },
  computed: {
    ...mapGetters(["servico", "user"]),
    isLeiInformatica() {
      return this.servico === BeneficiosEnum.LEI_DE_INFORMATICA;
    },
    beneficio() {
      return this.isLeiInformatica ? BeneficiosEnum.LEI_DE_INFORMATICA : BeneficiosEnum.LEI_DO_BEM;
    },
    nomeBeneficio() {
      return BeneficiosLabels[this.beneficio];
    },
    subtitulo() {
      return SUBTITULOS[this.beneficio];
    },
    temPermissao() {
      return userHasAccess(this.user, PERMISSOES[this.beneficio]);
    }
  }
};
</script>

<style lang="scss" scoped>
.dirbi-modulo {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.dirbi-modulo-beneficio {
  max-width: 265px;
}

.dirbi-modulo-corpo {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.dirbi-modulo-lb {
  flex: 1;
  min-height: 0;
}
</style>
